export const login = {
    contentLogin: 'Bạn có thể đăng nhập bằng tài khoản APP AIS',
    downloadApp: 'Tải App AIS',
    downloadInstructions: 'Hướng dẫn tải xuống',
    buttonLogin: 'Đăng nhập',
    passwordLabel: 'Mật khẩu',
    title: 'Đăng nhập',
    forGetPassword: "Quên mật khẩu?",
    register: "Đăng ký",
    noAccount: "Bạn chưa có tài khoản?"
};
